module.exports = __webpack_public_path__ + "static/OneDotExt-Bold.88a05086.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotExt-Bold.woff2
// module id = 749
// module chunks = 114276838955818